import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class PerfilEditDTO extends Serializable {
    @jsonProperty(String)
    username: string = '';

    @jsonProperty(String)
    email: string = '';

    @jsonProperty(String)
    nome: string = '';

    @jsonProperty(String)
    sobrenome: string = '';

    @jsonProperty(String)
    whatsapp: string = '';

    @jsonProperty(String)
    imageBase64: string = '';

    constructor() {
        super();
    }
}

export default PerfilEditDTO;
